// extracted by mini-css-extract-plugin
export default {"suggestionsItemText":"s4uiY8","suggestionsItem":"gmHVAz","selected":"bUFqbp","highlightedSymbols":"lHsvw6","categoryLabel":"KWZgN3","searchFadeIn":"r4WisY"};